// Account chrome uses the same authenticated client as the account page.
// Keep the last verified customer only in memory; never persist identity or tokens here.
if (!window.__nvHeaderAccountInitialized) {
 window.__nvHeaderAccountInitialized = true;
 let revision=0, retryTimer, lastCheck=0, verified=false, customer=null;
 const links=()=>document.querySelectorAll('.header-account-link');
 function paint(){
  if(!verified)return;
  const first=(customer?.first_name||'').trim(),last=(customer?.last_name||'').trim();
  const initials=(([...first][0]||'')+([...last][0]||'')||'Ú').toLocaleUpperCase('cs-CZ');
  for(const link of links()){
   const avatar=link.querySelector('.header-account-link__initials'),icon=link.querySelector('.svg-wrapper');
   if(!avatar||!icon)continue;
   avatar.textContent=customer?initials:'';avatar.hidden=!customer;icon.hidden=!!customer;
   link.dataset.accountState=customer?'authenticated':'guest';
   link.setAttribute('aria-label',customer&&first?'Můj účet – '+[first,last].filter(Boolean).join(' '):'Můj účet');
  }
 }
 async function refresh(attempt=0){
  clearTimeout(retryTimer);const current=++revision;lastCheck=Date.now();
  try{
   if(!window.NeviosAccount?.me)throw Error('Account client not ready');
   let timeout;
   const result=await Promise.race([window.NeviosAccount.me(),new Promise((_,reject)=>{timeout=setTimeout(()=>reject(Error('Account timeout')),10000);})]).finally(()=>clearTimeout(timeout));
   if(current!==revision)return;
   customer=result;verified=true;paint();
  }catch{
   if(current!==revision)return;
   // A network failure is not proof of logout. Retry only the read, never login actions.
   if(attempt<3)retryTimer=setTimeout(()=>refresh(attempt+1),[1000,3000,10000][attempt]);
  }
 }
 const resume=()=>{paint();if(Date.now()-lastCheck>15000)void refresh();};
 window.addEventListener('nv:account-changed',()=>refresh());
 window.addEventListener('pageshow',event=>{if(event.persisted)void refresh();else resume();});
 window.addEventListener('focus',resume);
 window.addEventListener('online',()=>refresh());
 document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='visible')resume();});
 document.addEventListener('shopify:section:load',()=>{paint();void refresh();});
 // Theme section replacement can create fresh account icons without a page load.
 new MutationObserver(records=>{
  if(records.some(record=>[...record.addedNodes].some(node=>node.nodeType===1&&(node.matches?.('.header-account-link')||node.querySelector?.('.header-account-link'))))){paint();resume();}
 }).observe(document.body,{childList:true,subtree:true});
 void refresh();
}
